const destinationDetails = {
    overview: 'Panoramica',
    pointsOfInterest: 'Punti di Interesse',
    activities: 'Attività',
    gallery: 'Galleria',
    map: 'Mappa',
    bookYourExperience: 'Prenota la tua esperienza',
    discoverOurTrips: 'Scopri i nostri viaggi che includono',
    wantToVisit: 'Vuoi visitare questa destinazione?',
    contactUsForTrip: 'Contattaci per organizzare il tuo viaggio personalizzato.',
    requestQuote: 'Richiedi Preventivo',
    breadcrumbDestinations: 'Destinazioni',
    breadcrumbActivities: 'Attività',
    cornoGrande: 'Corno Grande - La vetta più alta',
    campoImperatore: 'Campo Imperatore - Il "Piccolo Tibet"',
    rifugioDuca: 'Rifugio Duca degli Abruzzi',
    sentieroCentenario: 'Sentiero del Centenario',
    vistaPanoramica: 'Vista panoramica su tutto l\'Abruzzo',
    // Destination descriptions
    granSassoDescription: 'Il Gran Sasso d\'Italia è la vetta più alta degli Appennini continentali, raggiungendo i 2.912 metri di altezza. Questa montagna maestosa offre paesaggi mozzafiato, sentieri escursionistici per tutti i livelli e la possibilità di praticare sport invernali durante la stagione fredda.',
    granSassoSubtitle: 'Il Gigante degli Appennini',
    roccaCalascioDescription: 'Nel cuore del Parco Nazionale del Gran Sasso e Monti della Laga, Rocca Calascio è uno dei borghi più suggestivi d\'Abruzzo. Situato a oltre 1.400 metri di altitudine, questo piccolo gioiello regala viste mozzafiato e un\'atmosfera senza tempo. Il borgo, ormai semi-abbandonato, conserva un fascino unico tra ruderi in pietra, silenzio e panorami infiniti sulle montagne abruzzesi. Un luogo perfetto per chi cerca autenticità, bellezza e una connessione profonda con la natura e la storia.',
    roccaCalascioSubtitle: 'Il Borgo delle Nuvole',
    collaltoSabinoDescription: 'Arroccato su un colle tra i boschi e le colline della Sabina, Collalto Sabino è uno dei borghi più belli d\'Italia, ricco di fascino medievale e panorami mozzafiato. Mura in pietra, torri, stille steegjes e un castello perfettamente conservato lo rendono una tappa imperdibile per chi cerca autenticità, storia e bellezza fuori dalle rotte più turistiche. Un luogo dove il tempo sembra essersi fermato, ideale per una passeggiata rilassante e per immergersi nella magia di un\'Italia intima e nascosta.',
    collaltoSabinoSubtitle: 'Il Borgo Medievale della Sabina',
    santoStefanoDiSessanioDescription: 'Nel cuore del Parco Nazionale del Gran Sasso, Santo Stefano di Sessanio è uno dei borghi più affascinanti d\'Abruzzo. Un piccolo gioiello medievale in pietra calcarea bianca, perfettamente integrato nel paesaggio montano circostante. Ristrutturato con grande cura, il borgo ha mantenuto intatta la sua anima antica, diventando un simbolo del turismo lento e sostenibile. Un luogo dove ogni passo racconta una storia e ogni scorcio invita alla contemplazione.',
    santoStefanoDiSessanioSubtitle: 'Il Gioiello Medievale del Gran Sasso',
    trabocchiCoastDescription: 'La Costa dei Trabocchi è uno dei tratti costieri più suggestivi dell\'Adriatico, caratterizzato da antiche strutture di pesca in legno che si protendono sul mare come giganti addormentati. Questa costa, che si estende per circa 70 chilometri tra Ortona e Vasto, offre un paesaggio unico dove storia, tradizione e natura si fondono in armonia perfetta. I trabocchi, antiche macchine da pesca risalenti al XVIII secolo, sono oggi simboli di un\'arte marinara che resiste al tempo, circondati da spiagge incontaminate, calette nascoste e panorami mozzafiato sul mare cristallino.',
    trabocchiCoastSubtitle: 'La Costa Incantata dei Trabocchi',
    // Rocca Calascio points of interest
    castelloRoccaCalascio: 'Castello di Rocca Calascio - Tra i più alti castelli d\'Italia',
    chiesaSantaMaria: 'Chiesa di Santa Maria della Pietà - Gioiello ottagonale del XVII secolo',
    vistaPanoramica360: 'Vista panoramica a 360 gradi',
    borgoMedievale: 'Borgo medievale semi-abbandonato',
    sentieriPanoramici: 'Sentieri panoramici nelle montagne',
    // Alba Fucens points of interest
    anfiteatroRomano: 'Anfiteatro Romano - Uno dei meglio conservati dell\'Italia centrale',
    chiesaSanPietro: 'Chiesa di San Pietro - Edificata sui resti di un tempio pagano',
    vestigiaRomane: 'Vestigia romane e strade basolate',
    panoramiMonteVelino: 'Panorami sul Monte Velino',
    sitoArcheologico: 'Sito archeologico di rilevanza nazionale',
    // Activities
    mountainExcursions: 'Escursioni in montagna',
    rockClimbing: 'Arrampicata su roccia',
    wildlifeObservation: 'Osservazione della fauna selvatica',
    alpineCrossCountrySkiing: 'Sci alpino e sci di fondo',
    naturePhotography: 'Fotografia naturalistica',
    // Rocca Calascio specific activities
    panoramicWalk: 'Passeggiata panoramica nel borgo medievale',
    castleVisit: 'Visita al castello e alla chiesa',
    landscapePhotography: 'Fotografia paesaggistica',
    culturalImmersion: 'Immersione nella storia e nella cultura locale',
    // Alba Fucens specific activities
    archaeologicalWalk: 'Passeggiata archeologica tra le rovine',
    amphitheaterVisit: 'Visita all\'anfiteatro romano',
    churchExploration: 'Esplorazione della Chiesa di San Pietro',
    archaeologicalPhotography: 'Fotografia archeologica e paesaggistica',
    romanHistoryImmersion: 'Immersione nella storia romana',
    // Pescasseroli specific activities
    historicCenterWalk: 'Passeggiata rilassante nel centro storico',
    nationalParkExploration: 'Esplorazione del Parco Nazionale',
    localProductsDiscovery: 'Scoperta dei prodotti tipici locali',
    abruzzoCultureImmersion: 'Immersione nella cultura abruzzese',
    // Rocca di Mezzo specific activities
    villageCenterWalk: 'Passeggiata nel centro del borgo',
    historicStreetsExploration: 'Esplorazione delle vie e piazzette storiche',
    plateauTrailsWalk: 'Camminata sui sentieri dell\'altopiano',
    floraFaunaObservation: 'Osservazione della flora e fauna locale',
    mountainRhythmImmersion: 'Immersione nei ritmi lenti della montagna',
    // Collalto Sabino specific activities
    ancientVillageWalk: 'Passeggiata nel borgo antico',
    medievalStreetsExploration: 'Esplorazione delle stradine medievali',
    panoramicPointsVisit: 'Visita ai punti panoramici',
    baronialCastleDiscovery: 'Scoperta del castello baronale',
    medievalHistoryImmersion: 'Immersione nella storia medievale',
    // Santo Stefano di Sessanio specific activities
    medievalVillageWalk: 'Passeggiata nel borgo medievale',
    narrowStreetsExploration: 'Esplorazione delle viuzze e piazzette',
    artisanShopsVisit: 'Visita alle botteghe artigiane',
    mediceanTowerClimb: 'Salita alla Torre Medicea',
    silentBeautyImmersion: 'Immersione nella bellezza silenziosa',
    // Villetta Barrea specific activities
    villettaBarreaHistoricCenterWalk: 'Passeggiata nel centro storico',
    sunsetDeerWatching: 'Escursione guidata al tramonto per avvistamento cervi',
    villettaBarreaPanoramicTrailsExploration: 'Esplorazione dei sentieri panoramici',
    villettaBarreaWildlifeObservation: 'Osservazione della fauna selvatica',
    pristineNatureImmersion: 'Immersione nella natura incontaminata',
    // Pescocostanzo specific activities
    culturalHistoricCenterWalk: 'Passeggiata culturale nel centro storico',
    noblePalacesExploration: 'Esplorazione delle piazze e palazzi nobiliari',
    goldsmithTextileShopsVisit: 'Visita alle botteghe orafe e tessili',
    basilicaSantaMariaDiscovery: 'Scoperta della Basilica di Santa Maria del Colle',
    refinedAtmosphereImmersion: 'Immersione nella raffinata atmosfera del borgo',
    // Costa dei Trabocchi specific activities
    coastalPanoramicWalk: 'Passeggiata panoramica lungo la costa',
    historicTrabocchiVisit: 'Visita ai trabocchi storici',
    boatExcursionAlongCoast: 'Escursione in barca lungo la costa',
    freshFishTasting: 'Degustazione di pesce fresco',
    costaTrabocchiLandscapePhotography: 'Fotografia paesaggistica'
};

export default destinationDetails;
